import { Icon } from 'lib/ui/icon';

export const IssueUrgency = ({ issue }) => {
  if (!issue.urgent) {
    return null;
  }
  return <Icon glyph="urgent" />;
};
